import { Button } from "@/components/ui/button";

export function Footer() {
  return (
    <footer className="pt-20 px-[10px] pb-8 bg-transparent">
      <div
        className="w-full mx-auto"
        style={{ maxWidth: "calc(100vw - 20px)" }}
      >
        {/* Main Dark Container */}
        <div
          data-theme="dark"
          className="bg-[#151515] rounded-[40px] p-4 md:p-6 relative overflow-hidden"
        >
          {/* Bottom Links Section (Orange) */}
          <div className="bg-[#b85736] rounded-[30px] p-8 md:p-12 lg:p-16 relative overflow-hidden z-10 pl-5 pr-5">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-12 gap-x-8 mb-12 relative z-10 text-[#eee9e3] font-heading">
              {/* Col 1 */}
              <div className="col-span-2 md:col-span-1 flex flex-col items-start gap-8">
                <div className="text-lg font-medium tracking-wide">
                  <p>© TheOutpostCreative 2026</p>
                  <p className="text-base mt-1">Prev. "Edge Media Design"</p>
                </div>
                <a
                  href="/contact"
                  className="bg-[#eee9e3] text-[#151515] font-heading font-bold text-[16px] px-8 py-3 rounded-[8px] hover:bg-white transition-colors flex items-center justify-center"
                >
                  Get In Touch
                </a>
              </div>

              {/* Col 2 */}
              <div className="col-span-2 md:col-span-1 space-y-4 text-lg font-medium tracking-wide">
                <a
                  href="tel:4797150378"
                  className="block hover:text-white transition-colors"
                >
                  (479) 715-0378
                </a>
                <a
                  href="mailto:info@theoutpost.agency"
                  className="block hover:text-white transition-colors"
                >
                  info@theoutpost.agency
                </a>
                <div className="pt-2 leading-relaxed">
                  Based in Bentonville, AR.
                  <br />
                  Servicing all of the US.
                </div>
              </div>

              {/* Col 3 */}
              <ul className="col-span-1 space-y-4 text-lg font-medium tracking-wide">
                <li>
                  <a href="/" className="hover:text-white transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="/about"
                    className="hover:text-white transition-colors"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    href="/portfolio"
                    className="hover:text-white transition-colors"
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a href="/faq" className="hover:text-white transition-colors">
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    href="/blog"
                    className="hover:text-white transition-colors"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="/contact"
                    className="hover:text-white transition-colors"
                  >
                    Contact
                  </a>
                </li>
              </ul>

              {/* Col 4 */}
              <ul className="col-span-1 space-y-4 text-lg font-medium tracking-wide">
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    Web Design
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    SEO & Content
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    Meta Ads
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    Social Media
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="hover:text-white transition-colors"
                  >
                    Lead Gen Systems
                  </a>
                </li>
                <li>
                  <a
                    href="/seo-audit"
                    className="hover:text-primary transition-colors text-primary font-bold"
                  >
                    Free SEO Audit
                  </a>
                </li>
                <li>
                  <a
                    href="/get-found"
                    className="hover:text-primary transition-colors text-primary font-bold"
                  >
                    Get Found Playbook
                  </a>
                </li>
              </ul>

              {/* Col 5 */}
              <ul className="col-span-2 md:col-span-1 space-y-4 text-lg font-medium tracking-wide">
                <li>
                  <a
                    href="/privacy-policy"
                    className="hover:text-white transition-colors"
                  >
                    Privacy policy
                  </a>
                </li>
                <li>
                  <a
                    href="/terms-of-service"
                    className="hover:text-white transition-colors"
                  >
                    Terms of service
                  </a>
                </li>
                <li>
                  <a
                    href="/cookie-policy"
                    className="hover:text-white transition-colors"
                  >
                    Cookie policy
                  </a>
                </li>
                <li>
                  <a
                    href="/styleguide"
                    className="hover:text-white transition-colors"
                  >
                    Styleguide
                  </a>
                </li>
              </ul>
            </div>

            {/* Divider */}
            <hr className="border-t border-[#eee9e3]/30 my-12 relative z-10" />

            {/* Bottom Part */}
            <div className="flex flex-col-reverse lg:flex-row justify-between items-center lg:items-end gap-8 lg:gap-12 relative z-10 text-center lg:text-left">
              <div className="w-full lg:w-[70%] flex justify-center lg:justify-start">
                <img
                  src="https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69cf0a21d341385f5a2e9197.svg"
                  alt="The Outpost Creative Media"
                  className="w-full max-w-[800px] h-auto object-contain opacity-90"
                  width={800}
                  height={150}
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="w-full lg:w-[30%] flex flex-col items-center lg:items-end text-center lg:text-right space-y-4 lg:pb-4">
                <h2 className="font-heading font-medium text-[20px] text-[#eee9e3] uppercase leading-snug">
                  Ready to fill your calendar? Let's talk.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
